import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      ns="privacy"
      sectionKeys={["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10"]}
    />
  );
}
